import { TimerEditIcon } from './TimerEditIcon';

/**
 * author: Colton Wiscombe
 * id 046D48AE-58AE-472A-826A-F13F4859C0A3
 * name timer-edit
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-edit.svg
 * tags
 * - Date / Time 
 * - Edit / Modify 
 */
export const StopwatchEditIcon = TimerEditIcon;
export default StopwatchEditIcon